import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {assertNoBatching} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/image-op-utils"
import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/affine-transform/definition"
import {Matrix3x2} from "@cm/math"
import {
    getImgProcPixelAddressMode,
    IMGPROC_DEFAULT_INTERPOLATION_MODE,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/imgproc-utils"
import {computeResultSize} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/affine-transform/helpers"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {ImageOpAffineTransformHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/affine-transform/hal"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"

@registerNode
export class ImageOpNodeAffineTransform extends BasicSpecializingImageOpNode<typeof definition, ImageOpAffineTransformHal> {
    static nodeClass = "ImageOpNodeAffineTransform"
    static definition = definition

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpAffineTransformHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        assertNoBatching(evaluatedParameters.sourceImage.descriptor)
        const resultSize = evaluatedParameters.resultSize ?? computeResultSize(evaluatedParameters.sourceImage.descriptor, evaluatedParameters.transform)
        const resultImage = evaluator.context.createEmptyImage({
            ...resultSize,
            channels: evaluatedParameters.sourceImage.descriptor.channels,
        })
        return createImageOpImgProc(resultImage.descriptor, {
            type: "affineTransform",
            input: evaluatedParameters.sourceImage.node,
            transform: Matrix3x2.fromMatrix3x2Like(evaluatedParameters.transform).toArray(),
            borderMode: getImgProcPixelAddressMode(evaluatedParameters.addressMode),
            interpolationMode: IMGPROC_DEFAULT_INTERPOLATION_MODE,
            target: resultImage.node,
        })
    }
}
